import React, { Component } from 'react';
import cx from 'classnames';
import Pick from './Pick';

import {PHASE_GROUP_INDEX, PHASE_PICKS, PHASE_BANS} from './phases';

const list = [0,1,2,3,4];


function pad(number, size) {
  var s = String(number);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}

class Team extends Component {
  render() {
    return (
      <div className={cx({'team': true, 'current-team': this.props.turn})}>
        <h1>{this.props.name}
          <span className="team-phase">{this.props.phase && this.props.ready ? this.props.phase.substring(0, this.props.phase.length - 1) : ''}</span>
          <span className="team-timer">{this.props.phase && this.props.ready ? `:${pad(this.props.timer, 2)}`: ''}</span>
        </h1>
        <div className="team-picks">
          {list.map(i => <Pick key={i} champion={this.props.picks[i]} active={this.props.turn && this.props.phase === PHASE_PICKS && PHASE_GROUP_INDEX[this.props.round] === i && this.props.ready} />)}
        </div>
        <div className="team-picks bans">
          {list.map(i => <Pick key={i} champion={this.props.bans[i]} active={this.props.turn && this.props.phase === PHASE_BANS && PHASE_GROUP_INDEX[this.props.round] === i && this.props.ready} />)}
        </div>
      </div>
    );
  }
}

export default Team;



// WEBPACK FOOTER //
// ./src/Team.js